var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-box"},[_c('div',[_c('van-grid',{attrs:{"square":"","column-num":4,"border":false,"icon-size":"1rem"}},_vm._l((_vm.menuData),function(item,index){return _c('van-grid-item',{key:index,attrs:{"icon":item.file_url,"text":item.menu_name,"url":item.menu_href,"badge":item.count}})}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }